import React, { useState } from 'react';
import { Button, Typography, Box, Alert, Avatar } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

const TestUpload = () => {
    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [uploadResult, setUploadResult] = useState(null);
    const [error, setError] = useState(null);

    const handleImageSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file);
            const url = URL.createObjectURL(file);
            setPreviewUrl(url);
            setError(null);
        }
    };

    const handleUpload = async () => {
        if (!selectedImage) {
            setError('Seleziona prima un\'immagine');
            return;
        }

        const formData = new FormData();
        formData.append('avatar', selectedImage);

        try {
            const response = await axios.post('/elderly/1/avatar', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            setUploadResult(response.data);
            setError(null);
            
            // Dopo 2 secondi, reindirizza alla tabella per vedere il risultato
            setTimeout(() => {
                navigate(`${process.env.REACT_APP_BASE_PATH || '/dashboard'}/elderly`);
            }, 2000);
        } catch (err) {
            console.error('Upload error:', err);
            setError(err.response?.data?.message || 'Errore durante l\'upload');
        }
    };

    return (
        <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
            <Typography variant="h4" gutterBottom>
                Test Upload Avatar
            </Typography>

            <Box sx={{ mb: 3 }}>
                <input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="avatar-upload"
                    type="file"
                    onChange={handleImageSelect}
                />
                <label htmlFor="avatar-upload">
                    <Button
                       
                        component="span"
                        startIcon={<PhotoCameraIcon />}
                        sx={{ mb: 2 }}
                    >
                        Seleziona Immagine
                    </Button>
                </label>
            </Box>

            {previewUrl && (
                <Box sx={{ mb: 3, textAlign: 'center' }}>
                    <Typography variant="h6" gutterBottom>
                        Anteprima:
                    </Typography>
                    <Avatar
                        src={previewUrl}
                        sx={{ width: 100, height: 100, mx: 'auto', mb: 2 }}
                    />
                </Box>
            )}

            <Button
                variant="contained"
                color="primary"
                onClick={handleUpload}
                disabled={!selectedImage}
                sx={{ mb: 3 }}
            >
                Carica Avatar
            </Button>

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            {uploadResult && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    <Typography>Upload completato!</Typography>
                    <Typography variant="body2">
                        Percorso: {uploadResult.avatar_path}
                    </Typography>
                    <Button 
                        
                        size="small" 
                        onClick={() => navigate(`${process.env.REACT_APP_BASE_PATH || '/dashboard'}/elderly`)}
                        sx={{ mt: 1 }}
                    >
                        Vai alla Tabella Anziani
                    </Button>
                </Alert>
            )}
        </Box>
    );
};

export default TestUpload;